import { Checkbox, Hint } from "@ui";
import style from "./TableHead.module.scss";
import cn from "classnames";

export function TableHead() {
    return (
        <div className={style.head}>
            <div>Проксі</div>
            <div>Тариф</div>
            <div>Термін дії</div>
            <div className={cn("justify-self-center", style.hint)}>
                <p>Автопродовження</p>
                <Hint
                    targetElement={
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                            <path d="M7.66979 13.4999V13.5499H7.71979H9.27979H9.32979V13.4999V8.11988V8.06988H9.27979H7.71979H7.66979V8.11988V13.4999ZM9.23444 7.15593L9.23447 7.1559C9.42469 6.97272 9.51979 6.74285 9.51979 6.46988C9.51979 6.20947 9.42403 5.99541 9.23261 5.83216C9.04183 5.66277 8.79604 5.57988 8.49979 5.57988C8.20279 5.57988 7.95659 5.66655 7.76581 5.8432C7.57553 6.01938 7.47979 6.23938 7.47979 6.49988C7.47979 6.76039 7.57553 6.98038 7.76581 7.15657C7.95659 7.33322 8.20279 7.41988 8.49979 7.41988C8.80303 7.41988 9.04983 7.33343 9.23444 7.15593Z" fill="#A2AFD0" stroke="#A2AFD0" strokeWidth="0.1" />
                            <circle cx="8.5" cy="9" r="8" stroke="#A2AFD0" />
                        </svg>
                    }
                    hintText={<>Поповнюйте баланс для <br /> автопродовження проксі</>}
                />
            </div>
            <div className={"justify-self-center"}>Налаштування</div>
        </div>
    )
}